import { createContext, useContext } from 'react';
import { DataSetsProps, ReturnSyncDatasetsProps } from '@/types';
import { useDownloadFiles } from '@/talons/global-downloadFiles/useGlobalSync';

interface HookProps {
  isLoading: boolean;
  hasError: boolean;
  noUpdate: boolean;
  fileName: string;
  datasets: any[];
  preparing: boolean;
  isSuccess: boolean;
  isOpenedModal: boolean;
  downloadSpeedBps: number;
  fileDownload: string;
  fileDownloadProgress: string;
  startDownloadingFile: string;
  progressPercent: number;
  downloadingFiles: string[];
  downloadingFileName: string;
  isDownloadingFiles: string[];
  syncDatasets: (params: { 
    codPessoa: string;
    isBackground: boolean; 
    datasets?: DataSetsProps[];
  }) => Promise<ReturnSyncDatasetsProps>;
  setIsOpenedModal: (isOpenedModal: boolean) => void;
}

const SyncContex = createContext<HookProps>({} as HookProps);

const SyncProvider: React.FC<any> = ({ children }) => {
  const { 
    syncDatasets, 
    hasError, 
    noUpdate, 
    fileName, 
    datasets, 
    preparing, 
    isSuccess, 
    isOpenedModal, 
    downloadSpeedBps, 
    isLoading, 
    fileDownload,
    isDownloadingFiles,
    progressPercent,
    downloadingFiles,
    downloadingFileName,
    fileDownloadProgress,
    startDownloadingFile,
    setIsOpenedModal,
  } = useDownloadFiles();

  return (
    <SyncContex.Provider
      value={{
        isLoading,
        hasError,
        fileName,
        datasets,
        noUpdate,
        downloadingFiles,
        downloadingFileName,
        isDownloadingFiles,
        preparing,
        isSuccess,
        isOpenedModal,
        downloadSpeedBps,
        fileDownload,
        fileDownloadProgress,
        startDownloadingFile,
        progressPercent,
        syncDatasets,
        setIsOpenedModal,
      }}
    >
      {children}
    </SyncContex.Provider>
  );
};

const useSync = (): HookProps => {
  const ctx = useContext(SyncContex);

  if (!ctx) throw new Error('Erro ao usar hook Sync');

  return ctx;
};

export { SyncProvider, useSync };
